
import { BaseDocument } from "./base";
import { UserId } from "./helpers";
import { Money } from "./money";

export enum EApplicationType {
    TASK,
    PROJECT_MANAGER,
}

export enum EApplicationStatus {
    PENDING,
    ACCEPTED,
    REJECTED,
    WITHDRAWN,
    NOT_SELECTED,
    ACCEPTED_AND_CONFIRMED, // Freelancer confirmed after being accepted
    ACCEPTED_BUT_REFUSED, // Freelancer refused after being accepted
    TECH_PROBLEM, // there is an error with the application
    TASK_COMPLETED, // task already completed
    EXPIRED, // application expired
}

export interface Application extends BaseDocument {
    type: EApplicationType,
    freelancerId: string,
    projectId: string,
    taskId?: string,
    acceptedPayout?: number,
    status: EApplicationStatus,
    description: string | null,
    responseUser: UserId | null,
    responseDate: Date | null,
    confirmedOrRefusedAt: Date | null,
    expiresAt: Date | null,
}

export interface IApplication extends Partial<Application> { }
